/**
 * KpiCard — presentational stat tile: a label, a value, and an optional
 * hint (WSRPDM-0011).
 */
import { Paper, Typography } from '@mui/material';

interface KpiCardProps {
  label: string;
  value: string | number;
  hint?: string;
  /** Opt-in headline treatment for a primary metric; defaults preserve every existing card. */
  valueVariant?: 'h1' | 'h2';
}

export function KpiCard({ label, value, hint, valueVariant = 'h2' }: KpiCardProps) {
  return (
    <Paper variant="outlined" sx={{ p: 2, minWidth: 160 }}>
      <Typography
        variant="caption"
        component="p"
        color="text.secondary"
        sx={{ letterSpacing: '0.02em' }}
      >
        {label}
      </Typography>
      <Typography variant={valueVariant} component="p" sx={{ mt: 0.5, mb: hint ? 0.25 : 0 }}>
        {value}
      </Typography>
      {hint ? (
        <Typography variant="caption" component="p" color="text.secondary">
          {hint}
        </Typography>
      ) : null}
    </Paper>
  );
}
